/* eslint-disable no-unused-vars */
import { Box, Button, FormControlLabel, Theme, createStyles, makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import { getIsMobileApp } from '../../../utils/mobileApp';
import React from 'react';
import { LineupApiResponse, StackExposures } from '../../preContest/queries/queryTypes';
import { LineupApiResponse as PostLineupApiResponse, StackType } from '../../postContest/queries/queryTypes';
import { DataGridPro, GridColDef, useGridApiRef } from '@mui/x-data-grid-pro';
import { GridDensity, GridPagination, GridRowParams, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton, getGridStringOperators } from '@mui/x-data-grid';
import QuickFavorite from './QuickFavorite';
import ExposureIcon from '@material-ui/icons/Exposure';
import PlayerGroupsModal from './PlayerGroupsModal';
import PlayerManagementModal from './PlayerManagementModal';
import StackManagementModal from './StackManagementModal';
import { doesNotContain, positionFilters } from './customFilters';
import { ContestLineup, ContestPlayer, ContestStacks } from '../../contestGenerator/store/types';
import { GridApiPro } from '@mui/x-data-grid-pro/models/gridApiPro';
import { LateSwapLineup, LateSwapPlayer } from '../../lateSwap/store/types';
import { Projection } from '../EasyProjection/types';
import { MoonLoader } from 'react-spinners';
import { StyledSwitch } from '../_components';
import { setPlayerExposureCaps as setPlayerExposureDict, setStackExposureCaps as setStackExposureDict } from '../store/actions';
import { connect } from 'react-redux';
import { SitesResponse, SlateResponse, SportsResponse } from '../store/types';
import { Stack } from '@mui/material';
import QuickFilterToolbar from './QuickFilterToolbar';
import GameControls from '../GameControls/GameControls';
import { LineupRubric } from '../../LineupBuilder/store/types';
import { GridInitialStatePro } from '@mui/x-data-grid-pro/models/gridStatePro';
import LineupBuilderQuickFilterToolbar from '../LineupBuilderQuickFilterToolbar';
import { getContextualFilename } from '../helpers/FilenameHelper';
import { getFilterModel, updateFilters } from './saveFilterHelper';
import { CustomToolTip, toolTipText } from '../CustomToolTip';

const useStyles = makeStyles((theme: Theme) => createStyles({
  button: {
    color: 'white',

  },
  activeButton: {
    backgroundColor: "#003A85",
    color: 'white',
    '&:hover': {
      backgroundColor: "#003A85",
    },
  },
  buttonWrapper: {
    position: 'absolute',
    right: 0,
    display: 'flex',
    alignItems: 'center',
  },
  exportButton: {
    height: 40,
    width: 183,
    borderRadius: 3,
    // backgroundColor: '#0042C1',
    padding: '10px 16px',
    margin: '4px 0',
    marginLeft: 8,
    '& a': {
      color: 'white !important',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
    },
    '&:hover': {
      color: 'white',
      // backgroundColor: '#0042C1',
    },
    '& .MuiSvgIcon-root': {
      marginLeft: 4,
      fontSize: '1rem',
    },
  },
})
);

interface PlayerGroup {
  id: string;
  players: LineupApiResponse[];
  roiBoost: number;
}

interface OwnProps {
  readonly lineups: LineupApiResponse[] | PostLineupApiResponse[] | StackExposures[] | StackType[] | ContestPlayer[] | ContestLineup[] | ContestStacks[] | LateSwapLineup[] | LateSwapPlayer[] | Projection[] | LineupRubric[];
  readonly players?: LineupApiResponse[];
  readonly treeData?: boolean;
  readonly getTreeProps?: (row: any) => string[];
  readonly headers: GridColDef[];
  readonly isLoading: boolean;
  readonly emptyText?: string;
  readonly selectedView: string;
  readonly setPlayerList: (playerList: { [key: string]: number }) => void;
  readonly setStackList: (stackList: { [key: string]: number }) => void;
  readonly playerList?: { [key: string]: number };
  readonly stackList?: { [key: string]: number };
  readonly stackExposures?: LineupApiResponse[];
  readonly searchedUser?: string;
  readonly simType: string;
  readonly includeStacks: boolean;
  readonly setStackView: (view: string) => void;
  readonly stacks?: StackExposures[];
  readonly rowHeight?: number;
  readonly pagination?: boolean;
  readonly fontSize?: number;
  readonly compact?: GridDensity;
  readonly footer?: (apiRef: React.MutableRefObject<GridApiPro>) => JSX.Element;
  readonly tierlocked?: boolean;
  readonly getDetailPanelContent?: (params: GridRowParams<any>) => React.ReactNode;
  readonly projectionModal?: () => React.ReactNode;
  readonly backgroundColor?: string;
  readonly savedROIExposureKey?: string;
  readonly savedStackExposureKey?: string;
  readonly initialState?: GridInitialStatePro;
  readonly playerGroups?: PlayerGroup[];
  readonly setPlayerGroups?: (groups: PlayerGroup[]) => void;
  readonly allLineups?: LineupApiResponse[]; // For refavoriting from non-lineup tabs
  readonly isMobile?: boolean; // Mobile view flag
  readonly pinnedColumnsLeft?: string[]; // Columns to pin on left for mobile
  readonly hideToolbar?: boolean;
  readonly onApiRefReady?: (apiRef: React.MutableRefObject<GridApiPro>) => void; // Callback to expose apiRef to parent
}

interface ReduxProps {
  readonly stackExposureDict: { [key: string]: number };
  readonly playerExposureDict: { [key: string]: number };
  readonly selectedSport: SportsResponse;
  readonly selectedSite: SitesResponse;
  readonly selectedSlate: SlateResponse;
}

interface DispatchProps {
  readonly SetPlayerExposureDict: (playerList: { [key: string]: number }) => void;
  readonly SetStackExposureDict: (stackList: { [key: string]: number }) => void;
}

type Props = OwnProps & ReduxProps & DispatchProps;

const Table = (props: Props) => {
  const { projectionModal, initialState, savedROIExposureKey, savedStackExposureKey, backgroundColor, lineups, headers, isLoading, emptyText, selectedView, players, playerList, searchedUser, simType, includeStacks, stacks, stackList, pagination, fontSize, selectedSport, selectedSite, selectedSlate, compact = 'standard', treeData, stackExposureDict, playerExposureDict, SetPlayerExposureDict, SetStackExposureDict, getTreeProps, setStackList, setPlayerList, setStackView, footer, getDetailPanelContent, playerGroups: propsPlayerGroups, setPlayerGroups: propsSetPlayerGroups, allLineups, isMobile: isMobileProp, pinnedColumnsLeft, hideToolbar = false, onApiRefReady } = props;

  // Mobile detection - use prop if provided, otherwise detect via media query
  const theme = useTheme();
  const isMobileQuery = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = isMobileProp ?? isMobileQuery;
  const [openGroupsModal, setOpenGroupsModal] = React.useState(false);
  // Use props if provided, otherwise use local state (backwards compatibility)
  const [localPlayerGroups, setLocalPlayerGroups] = React.useState<PlayerGroup[]>([]);
  const playerGroups = propsPlayerGroups ?? localPlayerGroups;
  const setPlayerGroups = propsSetPlayerGroups ?? setLocalPlayerGroups;

  const [openPlayerModal, setOpenPlayerModal] = React.useState(false);
  const [openStackModal, setOpenStackModal] = React.useState(false);
  const [pinned, setPinned] = React.useState({} as PostLineupApiResponse);
  const apiRef = useGridApiRef();
  const classes = useStyles();

  // Expose apiRef to parent component if callback is provided
  React.useEffect(() => {
    if (onApiRefReady && apiRef.current) {
      onApiRefReady(apiRef);
    }
  }, [onApiRefReady, apiRef]);

  console.log('selectedView', selectedView);
  const localStorageKey = `${selectedSport.sport}-${selectedSite.site}-${selectedSlate.slateId}-${selectedView}-${simType}`;

  const visibleColumns = () => {
    const columnsToHide = {};
    const hiddenColumns = headers.filter((x) => x.field.includes('HIDE'));
    hiddenColumns.forEach((x) => {
      columnsToHide[x.field] = false;
    })

    return columnsToHide;
  }

  React.useEffect(() => {
    if (savedROIExposureKey) {
      const savedPlayerExposures = localStorage.getItem(savedROIExposureKey);
      if (savedPlayerExposures) {
        SetPlayerExposureDict(JSON.parse(savedPlayerExposures));
      }
    }
    if (savedStackExposureKey) {
      const savedStackExposures = localStorage.getItem(savedStackExposureKey);
      if (savedStackExposures) {
        SetStackExposureDict(JSON.parse(savedStackExposures));
      }
    }
  }, [])

  const columns = React.useMemo(
    () =>
      headers.map((col) => {
        const defaultFilters = getGridStringOperators() || [];

        if (col.type === 'number') {
          return col;
        }
        // If the column is a position column, add the position filters
        else if (col.field.includes('HIDE')) {
          return {
            ...col,
            filterOperators: [...defaultFilters, ...doesNotContain, ...positionFilters, ...col.filterOperators || []],
          }
        }
        // Otherwise, add the default filters and the does not contain filter
        return {
          ...col,
          filterOperators: [...defaultFilters, ...doesNotContain, ...col.filterOperators || []],
        };
      }
      ),
    [headers],
  );

  React.useEffect(() => {
    if (searchedUser && lineups.length > 0) {
      const typedLineups = lineups as PostLineupApiResponse[]
      const pinnedLineup = typedLineups?.find((x) => x.user?.toLowerCase() === searchedUser?.toLowerCase());
      setPinned({ ...pinnedLineup, id: 99999 } as PostLineupApiResponse);
    }
    else {
      setPinned({} as PostLineupApiResponse)
    }
  }, [searchedUser, lineups])

  if (!isLoading && lineups && (lineups?.length === 0 || Object.keys(lineups).length === 0)) {
    return (
      <Box minHeight={200} display='flex' alignItems={'center'} justifyContent='center' p={4} textAlign='center'>
        {emptyText ? emptyText : 'Start Simulation to see Results'}
      </Box>
    )
  }

  function CustomToolbar() {
    if (hideToolbar) {
      return null;
    }
    if (simType === 'lateSwap' && selectedView === 'exposures') {
      return (
        <GridToolbarContainer sx={{ borderTop: '1px solid rgba(255, 255, 255, 0.15)', px: '16px', minHeight: '50px' }}>
          <QuickFilterToolbar reverse={false} />
        </GridToolbarContainer>
      )
    } else if (simType === 'lateSwap' && selectedView === 'players') { 
      return null;
    }
    return (
      <GridToolbarContainer
        sx={{
          display: 'flex',
          gap: 2,
          py: 2,
          px: 2,
          justifyContent: 'space-between',
          borderTop: '1px solid rgba(255, 255, 255, 0.15)'
        }}
      >
        <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }} gap={1} flex={1} minWidth={0}>
          {
            ['projections', 'players', 'player', "playerExp"].indexOf(selectedView) >= 0 && (
              <QuickFilterToolbar reverse={selectedView === 'lineupBuilder'} />
            )
          }
          <Stack direction="row" alignItems="center" flexWrap="wrap" gap={0.5}>
            {
              ['lineupBuilder', 'lineupTable'].indexOf(selectedView) < 0 && (
                <>
                  <GridToolbarFilterButton
                    sx={{
                      color: 'inherit',
                      textAlign: 'center',
                      fontFamily: 'Inter',
                      fontSize: '12px',
                      fontStyle: 'normal',
                      fontWeight: 500,
                    }}
                  />
                  <GridToolbarColumnsButton
                    sx={{
                      color: 'inherit',
                      textAlign: 'center',
                      fontFamily: 'Inter',
                      fontSize: '12px',
                      fontStyle: 'normal',
                      fontWeight: 500,
                    }}
                  />
                </>
              )
            }
            {
              (simType === 'pre' || simType === 'dataHub' || simType.includes('post') || simType.includes('contest') || (selectedView === "exposures" && simType === "lateSwap")) && (
                <GridToolbarExport csvOptions={{ allColumns: true, escapeFormulas: false, fileName: getContextualFilename({
                  selectedSlate,
                  app: simType === 'dataHub' ? 'Data_Hub' : simType === 'pre' ? 'Pre_Contest' : simType === 'lateSwap' ? 'Late_Swap' : simType.includes('contest') ? 'Contest_Generator' : 'Data_Hub',
                  dataType: selectedView.charAt(0).toUpperCase() + selectedView.slice(1),
                  includeExtension: false, // GridToolbarExport adds .csv automatically
                }) }} printOptions={{ disableToolbarButton: true }} sx={{ color: 'inherit' }} />
              )
            }
            {
              ['projections'].indexOf(selectedView) >= 0 && selectedSlate.matchupInfo && (
                <GameControls variant="text" projectionVersion boostable onBoostApply={() => {}} localStorageKey={`easyProjectionGameControls-${selectedSite.site}-${selectedSport.sport}-${selectedSlate.slateId}`} />
              )
            }
            {
              ["lineupBuilder"].indexOf(selectedView) >= 0 && (
                <LineupBuilderQuickFilterToolbar reverse={selectedView === 'lineupBuilder'} showShowdownPositions={selectedView === 'lineupBuilder'} />
              )
            }
            {
              players && (
                <CustomToolTip title="Manage player ROI boosts and exposure caps">
                  <Button
                    variant="text"
                    size='small'
                    startIcon={<ExposureIcon style={{ fontSize: 14 }} />}
                    onClick={() => setOpenPlayerModal(true)}
                    style={{
                      color: 'white',
                      textTransform: 'uppercase',
                      fontSize: 12,
                      fontWeight: 500,
                      padding: '4px 0 4px 8px',
                      minWidth: 'auto',
                    }}>
                    Players {(Object.keys(playerList || {}).length > 0 || Object.keys(playerExposureDict || {}).length > 0) ? `(${Object.keys(playerList || {}).length + Object.keys(playerExposureDict || {}).length})` : ''}
                  </Button>
                </CustomToolTip>
              )
            }
            {
              (stacks && stacks.length > 0 && selectedView === 'lineups') && (
                <CustomToolTip title="Manage stack ROI boosts and exposure caps">
                  <Button
                    variant="text"
                    size='small'
                    startIcon={<ExposureIcon style={{ fontSize: 14 }} />}
                    onClick={() => setOpenStackModal(true)}
                    style={{
                      color: 'white',
                      textTransform: 'uppercase',
                      fontSize: 12,
                      fontWeight: 500,
                      padding: '4px 0 4px 8px',
                      minWidth: 'auto',
                    }}>
                    Stacks {(Object.keys(stackList || {}).length > 0 || Object.keys(stackExposureDict || {}).length > 0) ? `(${Object.keys(stackList || {}).length + Object.keys(stackExposureDict || {}).length})` : ''}
                  </Button>
                </CustomToolTip>
              )
            }
            {
              (players && ['lineups', 'playerExp'].includes(selectedView)) && (
                <Button
                  variant={playerGroups.length > 0 ? 'contained' : 'text'}
                  className={playerGroups.length > 0 ? classes.activeButton : classes.button}
                  startIcon={<ExposureIcon />}
                  size='small'
                  onClick={() => setOpenGroupsModal(true)}>
                    <CustomToolTip title="Create player groups to boost lineups containing all players in the group">
                      <Box>Groups</Box>
                    </CustomToolTip>
                </Button>
              )
            }
          </Stack>
        </Stack>
        {selectedView === 'lineups' && (
          <Box padding="4px">
            <QuickFavorite
              disabled={false} />
          </Box>
        )
        }
        {
          projectionModal && (
            projectionModal()
          )
        }
        {
          (includeStacks && (selectedView === 'playerExp' || selectedView === 'stackExp')) && (
            <FormControlLabel
              value={selectedView === 'stackExp'}
              checked={selectedView === 'stackExp'}
              onChange={(event, checked) => setStackView(checked ? 'stackExp' : 'playerExp')}
              control={<StyledSwitch />}
              label={simType.includes('post') ? "Stack Types" : "Stack Exposures"}
              labelPlacement="start"
            />
          )
        }
      </GridToolbarContainer>
    );
  }

  const handlePlayerExposureChange = (playerExposureList: { [key: string]: number }) => {
    if (savedROIExposureKey) {
      localStorage.setItem(savedROIExposureKey, JSON.stringify(playerExposureList));
    }
    SetPlayerExposureDict(playerExposureList);
  }

  const handleStackExposureChange = (stackExposureList: { [key: string]: number }) => {
    if (savedStackExposureKey) {
      localStorage.setItem(savedStackExposureKey, JSON.stringify(stackExposureList));
    }
    SetStackExposureDict(stackExposureList);
  }

  const customFooter = () => {
    return (
      <Box display="flex" justifyContent="space-between" alignItems="center">
        {
          pagination && (
            <GridPagination />
          )
        }
        {
          footer && (
            footer(apiRef)
          )
        }
      </Box>
    )
  }

  const pinnedRow = () => {
    if (Object.keys(pinned).length > 0) {
      return {
        top: [pinned],
        bottom: [],
      }
    }
    return {};
  }

  return (
    <>
      <DataGridPro
        key={`${selectedView}-${selectedSlate?.slateId}`}
        treeData={treeData}
        getTreeDataPath={getTreeProps}
        apiRef={apiRef}
        columns={columns}
        rows={lineups}
        localeText={{
          toolbarFilters: selectedView?.toUpperCase() === 'LINEUPS'  ? "Lineup Filters" : "Filters",
        }}
        rowHeight={isMobile ? 52 : 44}
        columnHeaderHeight={isMobile ? 45 : 32}
        disableColumnMenu={isMobile}
        sortingOrder={['desc', 'asc', null]}
        pinnedColumns={isMobile && pinnedColumnsLeft ? { left: pinnedColumnsLeft } : undefined}
        getRowId={(row) => selectedView === 'projections' ? row?.nameAndId || row?.id + 1 || row?.projectionRank : row?.id + 1 || row?.nameAndId || row?.projectionRank}
        showCellVerticalBorder
        scrollbarSize={0}
        pagination={pagination}
        rowSelection={false}
        showColumnVerticalBorder
        loading={isLoading}
        hideFooter={false}
        pinnedRows={pinnedRow()}
        onFilterModelChange={(model) => updateFilters(model, localStorageKey, selectedSlate)}
        getDetailPanelContent={getDetailPanelContent}
        getDetailPanelHeight={({ row }) => 'auto'}
        slots={{
          toolbar: CustomToolbar,
          footer: customFooter,
          loadingOverlay: () => <Box height={'100%'} display='flex' alignItems={'center'} justifyContent='center' ><MoonLoader color='white' /> </Box>,
        }}
        density={compact}
        slotProps={{
          toolbar: { printOptions: { disableToolbarButton: true } },
          panel: isMobile ? {
            sx: {
              maxWidth: '100vw',
              '& .MuiDataGrid-filterForm': {
                flexWrap: 'wrap',
                gap: 1,
                '& .MuiDataGrid-filterFormDeleteIcon': { flexBasis: 'auto' },
                '& .MuiDataGrid-filterFormLinkOperatorInput': { flexBasis: 'auto' },
                '& .MuiDataGrid-filterFormColumnInput': { flexBasis: '45%' },
                '& .MuiDataGrid-filterFormOperatorInput': { flexBasis: '45%' },
                '& .MuiDataGrid-filterFormValueInput': { flexBasis: '100%' },
              },
            },
          } : undefined,
        }}
        initialState={{
          sorting: {
            sortModel: [{ field: selectedView === 'lineupBuilder' ? 'salary' : (selectedView === 'playerExp' ? 'exposure' : 'simLineupRoi'), sort: 'desc' }],
          },
          columns: {
            columnVisibilityModel: {
              ...visibleColumns(),
              canBeAddedToPositions: false,
              // Hide position column on mobile (it's shown in the Player cell, but keep for filtering)
              ...(isMobile && selectedView === 'projections' && { position: false, team: false }),
            },
          },
          filter: {
            filterModel: getFilterModel(localStorageKey),
          },
          ...initialState
        }}
        sx={{
          color: 'common.white',
          height: simType === 'dataHub' ? `calc(100vh - ${getIsMobileApp() ? 236 : 200}px)` : '100%',
          maxHeight: simType === 'dataHub' ? `calc(100vh - ${getIsMobileApp() ? 236 : 200}px)` : undefined,
          fontSize: fontSize || '16px',
          border: 'none',
          '& .removed': {
            opacity: 0.6,
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: backgroundColor,
            height: '32px',
            fontSize: '12px',
            fontWeight: 800,
            textTransform: 'uppercase',
          },
          '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted):not(:hover) .MuiDataGrid-iconButtonContainer': {
            width: '0 !important',
            overflow: 'hidden',
          },
          '@media (hover: none), (pointer: coarse)': {
            '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-iconButtonContainer': {
              display: 'none',
            },
          },
          '& .MuiDataGrid-cell:has(div.playerLocked)': {
            backgroundColor: '#333333',
            color: '#979797',
            '& .MuiSvgIcon-root':
            {
              color: '#979797',
            }
          },
          '& .playerLocked': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& .MuiSvgIcon-root': {
              fontSize: '20px',
              color: '#979797',
            }
          },
          '& .conditionalFormatted': {
            padding: 0,
          },
          "::-webkit-scrollbar-thumb": { backgroundColor: 'red', },
          '& .MuiDataGrid-pinnedRows': {
            backgroundColor: '#000A16',
            '& .MuiDataGrid-row': {
              backgroundColor: 'rgba(251,255,57, 0.15) !important',
              // borderColor: '1px solid rgba(251,255,57, 0.5) !important',
            }
          },
          '& .MuiDataGrid-row.Mui-hovered': {
            backgroundColor: '#000A16',
          },
          '& .MuiDataGrid-row:nth-of-type(even)': {
            borderColor: 'rgba(251,255,57, .3)',
            backgroundColor: 'rgba(255, 255, 255, .04)',
            '& .MuiDataGrid-row.Mui-hovered': {
            },
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
            width: '0px',
            height: 14,
            padding: 8,
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '& .MuiDataGrid-virtualScroller': {
            '&::-webkit-scrollbar': {
              display: 'none'
            },
            /* Hide scrollbar for IE, Edge and Firefox */
            'MsOverflowStyle': 'none',  /* IE and Edge */
            'scrollbarWidth': 'none',  /* Firefox */
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
            backgroundColor: '#122A4A',
            borderRadius: 4,
            borderTop: '3px transparent solid',
            borderBottom: '3px transparent solid',
            backgroundClip: 'padding-box',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#122A4A',
            borderRadius: 4,
            borderTop: '3px transparent solid',
            borderBottom: '3px transparent solid',
            backgroundClip: 'padding-box',
          },
          '& .MuiDataGrid-row': {
            '& .MuiDataGrid-row.Mui-hovered': {
              backgroundColor: simType?.toLowerCase() === 'lateswap' ? '#000A16' : '#000A16',
            },
          },
          '& .MuiDataGrid-pinnedColumnHeaders': {
            backgroundColor: '#000A16',
          },
          '& .MuiDataGrid-pinnedColumns': {
            backgroundColor: '#000A16',
          },
          '& .MuiDataGrid-withBorderColor': {
            border: 'none'
          },
          '& .MuiDataGrid-iconButtonContainer svg': {
            color: 'common.white',
          },
          '& .MuiDataGrid-iconButtonContainer span': {
            color: 'common.white',
          },
          '& .MuiSvgIcon-root': {
            color: 'common.white',
          },
          '& .MuiToolbar-root': {
            color: 'common.white',
          },
        }}
      />
      <PlayerManagementModal
        open={openPlayerModal}
        players={players || []}
        playerRoiList={playerList || {}}
        playerExposureList={playerExposureDict || {}}
        stackRoiList={stackList || {}}
        stackExposureList={stackExposureDict || {}}
        setPlayerRoiList={(list) => setPlayerList(list)}
        setPlayerExposureList={(list) => handlePlayerExposureChange(list)}
        closeModal={() => setOpenPlayerModal(false)}
        selectedSlate={selectedSlate}
        onAdjustFavorites={() => {}}
        apiRef={apiRef}
        allLineups={allLineups || lineups as LineupApiResponse[]}
      />
      <StackManagementModal
        open={openStackModal}
        stacks={stacks || []}
        stackRoiList={stackList || {}}
        stackExposureList={stackExposureDict || {}}
        playerExposureList={playerExposureDict || {}}
        setStackRoiList={(list) => setStackList(list)}
        setStackExposureList={(list) => handleStackExposureChange(list)}
        closeModal={() => setOpenStackModal(false)}
        selectedSlate={selectedSlate}
        onAdjustFavorites={() => {}}
        players={players}
        apiRef={apiRef}
      />
      <PlayerGroupsModal
        open={openGroupsModal}
        players={players || []}
        lineups={allLineups || lineups as LineupApiResponse[]}
        closeModal={() => setOpenGroupsModal(false)}
        selectedSlate={selectedSlate}
        playerGroups={playerGroups}
        setPlayerGroups={setPlayerGroups}
        playerExposureDict={playerExposureDict || {}}
        stackExposureDict={stackExposureDict || {}}
        playerRoiList={playerList || {}}
        stackRoiList={stackList || {}}
        onAdjustFavorites={() => {}}
        apiRef={apiRef}
      />
    </>
  );
};

const mapDispatchToProps = {
  SetPlayerExposureDict: setPlayerExposureDict,
  SetStackExposureDict: setStackExposureDict,
};

const mapStateToProps = (state: any) => {
  const {
    stackExposureDict,
    playerExposureDict,
    selectedSport,
    selectedSite,
    selectedSlate
  } = state.common;
  return {
    stackExposureDict,
    playerExposureDict,
    selectedSport,
    selectedSite,
    selectedSlate
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Table);